import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { BBPLMonitor } from 'packages/bbplMonitor/ui/BBPLMonitor';
import { useCreditFacilityContext } from 'packages/credit-facility/hooks/CreditFacilityProvider';

export const BBPLMonitorRoute = ({
  organizationId,
}: {
  organizationId: string;
}) => {
  const { creditFacilityId } = useCreditFacilityContext();
  // @bbplMonitor: use creditFacilityId
  // eslint-disable-next-line no-console
  console.log({ creditFacilityId });

  return (
    <Switch>
      <Route
        exact
        path="/bbpl-monitor"
        render={(routeProps) => (
          <BBPLMonitor {...routeProps} organizationId={organizationId} />
        )}
      />{' '}
    </Switch>
  );
};
